
export class Seat {
  private _code: string;
  private _subjectToSeatSelectionFee: boolean;
  private _type: string;
  private _currency: any;

  constructor(value: {segmentCode?: string, segmentChoice?:any, seatInfo?:any }) {
    const {segmentCode, segmentChoice, seatInfo } = value;

    if (segmentChoice) {
      this.seatFromApi(segmentChoice.seat, segmentChoice.seatSelectionFee)
    }
    else {
      this.createSeat(segmentCode, seatInfo)
    }
  }

  get code(): string {
    return this._code;
  }

  set code(code: string) {
    this._code = code;
  }

  get subjectToSeatSelectionFee(): boolean {
    return this._subjectToSeatSelectionFee;
  }

  set subjectToSeatSelectionFee(subjectToSeatSelectionFee: boolean) {
    this._subjectToSeatSelectionFee = subjectToSeatSelectionFee;
  }

  get type(): string {
    return this._type;
  }

  set type(type: string) {
    this._type = type;
  }

  get currency(): any {
    return this._currency;
  }

  set currency(currency: any) {
    this._currency = currency;
  }

  clearSeat() {
    this._code = null;
    this._currency = null;
  };

  getSeatBalance() {
    if (this.currency != null && this.currency.total != null) {
      return this.currency.total;
    }
    return 0;
  };

  private createSeat(seatId, seatInfo) {
    this._code = seatId;
    this._subjectToSeatSelectionFee = seatInfo.choice.subjectToSeatSelectionFee;
    if (seatInfo.choice.currency != null) {
      this._type = seatInfo.choice.type;
      this._currency = seatInfo.choice.currency;
    }
  }

  seatFromApi(seat, seatSelectionFee) {
    var seatInfo = {
      choice: {
        _meta: seat._meta,
        currency: seat.currency,
        type: seat.type
      }
    };

    if (!seatInfo.choice.currency) {
      seatInfo.choice.currency = seatSelectionFee;
    }

    if ((!seatInfo.choice.type) && seatSelectionFee) {
      seatInfo.choice.type = "seatSelectionFee";
    }
    this.createSeat(seat.legCode, seatInfo);
  };

}
